<template>
    <SidePanel>
        <template #title>
            <strong>Expert</strong>&nbsp;Mode
        </template>
        <template #content>
            <slot></slot>
        </template>
    </SidePanel>
</template>

<script>
import SidePanel from '@/components/flow/sides/SidePanel.vue'

export default {
    name: 'SidePanelExpert',
    components: {
        SidePanel
    }
}
</script>
